import createSocketIoMiddleware from 'redux-socket.io';
import Const from 'constants';
import socket from 'services/socket-io';

export const socketIoMiddleware = createSocketIoMiddleware(socket, Const.SOCKET_PATH_PREFIX, {
    execute: function (action, emit, next, dispatch) {
        if (action.type === Const.SOCKET_SUBSCRIBE) {
            console.log('subscribe to room #' + action.roomId);
            const {options = {}} = action;
            emit('subscribe', action.roomId, options);
        } else if (action.type === Const.SOCKET_UNSUBSCRIBE) {
            console.log('unsubscribe from room #' + action.roomId);
            emit('unsubscribe', action.roomId);
        }

        return next(action);
    },
});
